import { Box, Tab, Tabs } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import AveragedCalibrationsTable from "./averaged-calibration-table";
import {
  getBaseAveragedCalibrations,
  getBrandAveragedCalibrations,
  getManufacturerAveragedCalibrations,
  getModelAveragedCalibrations,
} from "../utils/NetworkHandler";
import ImportExportFileButtons from "../import-export/import-export-buttons";

function sortAll(data = []) {
  return [...data]
    .map((item) => ({
      ...item,
      components: Array.isArray(item.components)
        ? [...item.components].sort((a, b) => {
            const leftId = a?.deviceCalibration?.id || "";
            const rightId = b?.deviceCalibration?.id || "";
            return leftId.localeCompare(rightId);
          })
        : [],
    }))
    .sort((a, b) => (a?.id || "").localeCompare(b?.id || ""));
}

export default function AveragedCalibrationsPage({ isDetailedData }) {
  const [rowsData, setRowsData] = useState([]);
  const [clickedOption, setClickedOption] = useState(0);

  const getDataFromBackend = useCallback(async () => {
    let response;

    switch (clickedOption) {
      case 0:
        response = await getBaseAveragedCalibrations();
        break;
      case 1:
        response = await getManufacturerAveragedCalibrations();
        break;
      case 2:
        response = await getBrandAveragedCalibrations();
        break;
      case 3:
        response = await getModelAveragedCalibrations();
        break;
      default:
        setRowsData([]);
        return;
    }

    setRowsData(sortAll(response?.data || []));
  }, [clickedOption]);

  useEffect(() => {
    getDataFromBackend();
  }, [getDataFromBackend]);

  return (
    <Box>
      <ImportExportFileButtons updateData={getDataFromBackend} />
      <Tabs
        value={clickedOption}
        onChange={(event, newValue) => setClickedOption(newValue)}
        indicatorColor="primary"
        textColor="primary"
        aria-label="opcje uśrednionych kalibracji"
      >
        <Tab label="Bazowa" value={0} />
        <Tab label="Producent" value={1} />
        <Tab label="Marka" value={2} />
        <Tab label="Model" value={3} />
      </Tabs>

      <AveragedCalibrationsTable
        data={rowsData}
        clickedOption={clickedOption}
        removeGroupHandler={getDataFromBackend}
        updateData={getDataFromBackend}
        isDetailedData={isDetailedData}
      />
    </Box>
  );
}
